// extracted by mini-css-extract-plugin
export default {"container":"SuperConsole_container__eybic","tabContent":"SuperConsole_tabContent__Yn7no"};